import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import api from 'store/middleware/api'
import rootReducer from './reducers'

// import logger from "./middleware/logger";

const store = configureStore({
  reducer: rootReducer,
  middleware: [...getDefaultMiddleware(), api]
})

export default store
